import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categoryFamily", "category", "subCategory"]
  static values = {
    storeId: Number
  }

  connect() {
    const familyId = this.categoryFamilyTarget?.dataset.selected
    const categoryId = this.categoryTarget?.dataset.selected
    const subCategoryId = this.subCategoryTarget?.dataset.selected

    if (familyId) {
      this.fetchCategories(familyId, categoryId, subCategoryId)
    } else if (categoryId) {
      // If no category family, but category is selected (non-nested setup)
      this.populateCategoryOnly(categoryId, subCategoryId)
    }
  }

  categoryFamilyChanged(event) {
    const familyId = event.target.value
    this.fetchCategories(familyId)
  }

  categoryChanged(event) {
    const categoryId = event.target.value
    this.fetchSubCategories(categoryId)
  }

  fetchCategories(familyId, preselectCategoryId = null, preselectSubCategoryId = null) {
    this.clearSelect(this.categoryTarget)
    this.clearSelect(this.subCategoryTarget)

    if (!familyId) return

    fetch(`/category_families/${familyId}/categories?store_id=${this.storeIdValue}`)
      .then(res => res.json())
      .then(data => {
        this.populateSelect(this.categoryTarget, data.categories, preselectCategoryId)

        // If editing, trigger categoryChanged manually
        if (preselectCategoryId) {
          this.fetchSubCategories(preselectCategoryId, preselectSubCategoryId)
        }
      })
  }

  fetchSubCategories(categoryId, preselectId = null) {
    this.clearSelect(this.subCategoryTarget)

    if (!categoryId) return

    fetch(`/categories/${categoryId}/sub_categories?store_id=${this.storeIdValue}`)
      .then(res => res.json())
      .then(data => {
        this.populateSelect(this.subCategoryTarget, data.sub_categories, preselectId)
      })
  }

  populateSelect(selectElement, options, selectedId = null) {
    selectElement.innerHTML = '<option value="">Select</option>'
    options.forEach(([id, name]) => {
      const option = document.createElement("option")
      option.value = id
      option.textContent = name
      if (selectedId && parseInt(selectedId) === id) {
        option.selected = true
      }
      selectElement.appendChild(option)
    })
  }

  clearSelect(selectElement) {
    if (!selectElement) return
    selectElement.innerHTML = '<option value="">Select</option>'
  }

  populateCategoryOnly(categoryId, subCategoryId) {
    // Optional: preload categories if not using families
    this.fetchSubCategories(categoryId, subCategoryId)
  }
}